// Derivações puras dos números de pesquisa. Ficam fora dos componentes de propósito: são
// as contas que definem o que a tela mostra e o único jeito de testá-las sem montar Vue.

export const NPS_DETRACTOR_MAX = 6;
export const NPS_PASSIVE_MAX = 8;
export const CSAT_SATISFIED_MIN = 4;

/**
 * Faixa do NPS de uma nota: 0-6 detrator, 7-8 neutro, 9-10 promotor.
 */
export const npsSegment = rating => {
  if (rating === null || rating === undefined) return null;
  if (rating <= NPS_DETRACTOR_MAX) return 'detractor';
  if (rating <= NPS_PASSIVE_MAX) return 'passive';
  return 'promoter';
};

/**
 * Score do NPS: %promotores − %detratores, arredondado, de -100 a 100.
 * Devolve null sem respostas — zero ali seria mentira (zero é um score real, e ruim).
 */
export const computeNpsScore = ({
  promoters = 0,
  detractors = 0,
  total = 0,
}) => {
  if (!total) return null;
  return Math.round(((promoters - detractors) / total) * 100);
};

/**
 * Score de satisfação do CSAT: percentual de notas 4 e 5.
 */
export const csatSatisfactionScore = ({ satisfied = 0, total = 0 }) => {
  if (!total) return null;
  return Math.round((satisfied / total) * 100);
};

/**
 * Taxa de resposta: respondidas sobre perguntadas.
 */
export const responseRate = ({ responses = 0, sent = 0 }) => {
  if (!sent) return null;
  return Math.round((responses / sent) * 100);
};

/**
 * Conta as faixas a partir do mapa `{ nota: quantidade }` que a API devolve.
 */
export const segmentCounts = (ratingsCount = {}) => {
  const counts = { promoters: 0, passives: 0, detractors: 0, total: 0 };

  Object.entries(ratingsCount).forEach(([rating, count]) => {
    const value = Number(count) || 0;
    const segment = npsSegment(Number(rating));
    counts.total += value;
    if (segment === 'promoter') counts.promoters += value;
    else if (segment === 'passive') counts.passives += value;
    else counts.detractors += value;
  });

  return counts;
};

/**
 * Total de notas 4-5 e total geral, para o score de satisfação do CSAT.
 */
export const csatCounts = (ratingsCount = {}) => {
  let satisfied = 0;
  let total = 0;

  Object.entries(ratingsCount).forEach(([rating, count]) => {
    const value = Number(count) || 0;
    total += value;
    if (Number(rating) >= CSAT_SATISFIED_MIN) satisfied += value;
  });

  return { satisfied, total };
};
